import React from 'react';
import HeroImg from './images/hero/1.webp';
import HeroImg2 from './images/allimages/9.webp';
import dots from './images/hero/sqovert3.png';
import { Link } from 'react-router-dom';
import './css/hero.css';
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';

const Hero = () => {
  const { language } = useLanguage();
  const { content, loading } = useContent();
  
  // Get content from API or fallback to translations
  const getHeroContent = (field) => {
    if (content?.hero) {
      const langKey = language === 'ar' ? `${field}_ar` : `${field}_en`;
      return content.hero[langKey] || content.hero[field] || '';
    }
    return '';
  };

  const subtitle = getHeroContent('subtitle') || (language === 'ar' ? 'ماذا نقدم ؟' : 'What We Offer');
  const title = getHeroContent('title') || (language === 'ar' ? 'مؤسسة عبد الله عيد الحتيرشي للمقاولات ACPCA' : 'Abdullah Eid Al-Hatirshi Contracting Company');
  const description = getHeroContent('description') || (language === 'ar' ? 'تأسست مؤسسة عبد الله عيد الحتير شي في عام 2010 بمكة المكرمة, لتنطلق في عالم الأعمال المدنية مع تركيز خاص على مشاريع البنية التحتية' : 'Abdullah Eid Al-Hatirshi Company was established in 2010 in Makkah, to launch into the world of civil works with a special focus on infrastructure projects');
  const cta = getHeroContent('cta') || (language === 'ar' ? 'هل تريد التواصل معنا' : 'Do you want to contact us');
  
  const heroImage = content?.hero?.image_url || HeroImg;
  const heroBgImage = content?.hero?.background_image_url || HeroImg;

  return (
    <section className='hero'>
      <img src={dots} alt="dots" className='dots'/>
      <img src={heroBgImage} alt="Hero" className='hero-img'/>

      <div className="overlay"></div>

        <div className='container'>
            <div className='row'>

            <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className="right-content">
                      <img src={heroImage} alt="Hero2" />
                    </div>
                </div>


                <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className="left-content">
                      <h2>{subtitle}</h2>
                      <h1>{title}</h1>
                      <p>{description}</p>
                      <Link to="/contact">{cta}</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Hero
